<template>
  <div class="dataTable">
    <DataBox
      ref="dataBox"
      v-for="i in indexes.length"
      :key="i"
      :profile="profile"
      :editMode="$parent.ownProfile"
      :dataListIndex="indexes[i - 1]"
    />
  </div>
</template>

<script>
import DataBox from "@/components/profile/DataBox";
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";

export default {
  name: "DataTable",
  components: { DataBox },
  props: {
    indexes: Array,
    profile: Object
  },

  data() {
    return {};
  },

  methods: {
    onSave: function() {
      const dataLists = [];

      this.$refs.dataBox.forEach(elt => {
        elt.save();
        elt.dataListContainer.className = "profile.data.CProfileDataList";
        dataLists.push(elt.dataListContainer);
      });
      idyuJsonRpc("updateDataList", dataLists);
    }
  }
};
</script>

<style scoped lang="scss">
.dataTable {
  display: grid;
  align-items: center;
}
</style>
